import { useQuery } from '@tanstack/react-query';
import { useAccount } from 'wagmi';
import { SchemaSubaccountBalanceDto } from '../generated/apiTypes';
import { apiClient } from '../lib/apiClient';
import { Gwei } from '../lib/gwei';

const transformBalance = (data: SchemaSubaccountBalanceDto[]) =>
  data.map((bal) => ({
    ...bal,
    amount: Gwei.toGwei(bal.amount),
    available: Gwei.max(Gwei.toGwei(bal.available), 0n),
    totalUsed: Gwei.toGwei(bal.totalUsed),
  }));

export type SubaccountBalance = ReturnType<typeof transformBalance>;

export const subaccountBalanceQuery = (subaccountId: string | undefined) =>
  apiClient.queryOptions('get', '/v1/subaccount/balance', {
    params: { query: { subaccountId: subaccountId || '' } },
  });

export const useSubaccountBalance = (subaccountId: string | undefined) => {
  const { address } = useAccount();
  return useQuery({
    ...subaccountBalanceQuery(subaccountId),
    select: (data) => transformBalance(data.data),
    enabled: Boolean(subaccountId && address),
  });
};
